export const audienceSetOptions = {
  APP: "app",
  DEVICE_TYPE: "deviceType",
  DUSN: "dusn",
  USER: "user"
};
